export const CREATE_USER_FEV_ACTION = '[User_FEV Action] Create User_FEV';
export const CONFIRMED_CREATE_USER_FEV_ACTION = '[User_FEV Action] Confirmed Create User_FEV';
export const CREATE_USER_FEV_ERROR_ACTION = '[User_FEV Action] Create User_FEV Error';
export const GET_USER_FEVS = '[User_FEV Action] Get User_FEVs';
export const CONFIRMED_GET_USER_FEVS = '[User_FEV Action] Confirmed Get User_FEVs';
export const LOADING_USER_FEVS = '[User_FEV Action] Loading for User_FEVs';
export const EDIT_USER_FEV_ACTION = '[User_FEV Action] Edit User_FEV';
export const CONFIRMED_EDIT_USER_FEV_ACTION = '[User_FEV Action] Confirmed Edit User_FEV';
export const DELETE_USER_FEV_ACTION = '[User_FEV Action] Delete User_FEV';
export const CONFIRMED_DELETE_USER_FEV_ACTION = '[User_FEV Action] Confirmed Delete User_FEV';
export const USER_FEV_ERROR_ACTION = '[User_FEV Action] Error';
export const CLEAR_USER_FEV_ERROR = '[User_FEV Action] Clear Error';

